import React, { useCallback, useRef, useState } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import { FiChevronRight, FiChevronLeft, FiCheck } from 'react-icons/fi';




const ImageGallery = ({ galleryImages }) => {
	const [thumbsSwiper, setThumbsSwiper] = useState('');

	const sliderRef = useRef(null);

	const handlePrev = useCallback(() => {
		if (!sliderRef.current) return;
		sliderRef.current.swiper.slidePrev();
	}, []);

	const handleNext = useCallback(() => {
		if (!sliderRef.current) return;
		sliderRef.current.swiper.slideNext();
	}, []);
	return (
		<>
			<Swiper
				style={{
					"--swiper-navigation-color": "#fff",
					"--swiper-pagination-color": "#fff",
				}}
				spaceBetween={10}

				navigation={{
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				}}
				thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : '' }}
				modules={[FreeMode, Navigation, Thumbs]}
				className="singleImageGalleryImages rounded-lg mb-1 relative swiper-slide-car "
			>




				{galleryImages && galleryImages.map((gallery, i) => {
					return (
						<SwiperSlide>
							{gallery.video ?

								<div className=" relative aspect-w-16 aspect-h-9 h-[350px] md:h-[450px] lg:h-[600px] overflow-hidden bg-jacarta-900">

									<video
										loop muted autoPlay controls=''
										className="absolute w-full h-full object-cover"
									>
										<source src="/scan.mp4" type="video/mp4" />
										Your browser does not support the video tag.
									</video>


								</div>
								:
								<Image src={`${gallery.img}`}
									className="rounded-[10px]"
									fill sizes="(max-width: 768px) 100vw, (max-width: 1200px) 75vw" alt={`gallery-image-${i}`} />}
						</SwiperSlide>
					)
				})}
				<div onClick={handlePrev} className="swiper-button-prev flex justify-center items-center  cursor-pointer">



					{/* <FiChevronLeft className="text-xl  w-6 h-6  " /> */}
				</div>
				<div onClick={handleNext} className="swiper-button-next flex justify-center items-center  cursor-pointer">
					{/* <FiChevronRight className="text-xl  w-6 h-6" /> */}
				</div>
			</Swiper>
			<Swiper
				onSwiper={setThumbsSwiper}
				spaceBetween={5}
				slidesPerView={8}
				watchSlidesProgress
				modules={[Navigation, Thumbs]}
				className="singleImageGalleryThumbs cursor-pointer rounded-b-md mt-2"
			>

				{galleryImages && galleryImages.map((gallery, i) => {
					return (
						<SwiperSlide>
							<Image src={`${gallery.video ? gallery.videoImg : gallery.img}`}
								fill sizes="(max-width: 768px) 100vw, (max-width: 1200px) 75vw" className="rounded-md object-cover" alt={`gallery-thumb-${i}`} />
						</SwiperSlide>
					)
				})}
			</Swiper>
			<style>
				{`
                img{
                    object-fit:cover
                }
                `}
			</style>
		</>
	);
};
export default ImageGallery;